import { Component, OnDestroy, OnInit } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';



@UntilDestroy()
@Component({
  selector: 'mydocma-mm-no-rows-overlay',
  template: `
  <div>
    <i > {{'MM.general.noRecords' | translate}} </i>
  </div>`,
})

export class CustomNoRowsOverlay implements INoRowsOverlayAngularComp, OnInit, OnDestroy {


  constructor(
    private readonly translateService: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  agInit(params: INoRowsOverlayParams): void {
  }

  ngOnDestroy(): void {
  }
}
